import { FC } from 'react';
import { IconTextContainer } from './styled';

type Props = {
  ani: boolean;
  name: string;
  sentence: string;
  direction: string;
};

const IconText: FC<Props> = ({ ani, name, sentence, direction }) => {
  return (
    <IconTextContainer $ani={ani} className={direction}>
      {sentence}
      <span>{name}</span>
    </IconTextContainer>
  );
};
export default IconText;
